import { render } from "./QActsPreloader.vue?vue&type=template&id=6efac723&scoped=true"
const script = {}

import "./QActsPreloader.vue?vue&type=style&index=0&id=6efac723&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6efac723"]])

export default __exports__